import React, { useState,useEffect } from 'react';
import { IonList,IonLabel,IonButton, IonItem,IonRange,IonIcon, IonText } from '@ionic/react';



interface ContainerProps {
    title: string;
    description: string;
    name: string;
  min:number;
  max:number;
  defaultValue:number;
  step:number;
  handler:(value:number)=>void;
}
const customFormatter = (value: number) => `${value}`;

const Control: React.FC<ContainerProps> = ({ title,description,name,min,max,defaultValue,step,handler }) => {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        handler(value);
        
    }, [value]);


    return (
        <IonList>
            <IonItem className="" lines="none"  >
                <div className="Param" style={{textAlign:"center"}}>
                    <IonText >{title}</IonText>
                </div>
            </IonItem>
            <IonItem className=" f1 text-center w-100" style={{textAlign:"center"}}  lines="none" >
            <div  className="ParamDetail" style={{textAlign:"center"}}>
                {description}: <IonButton color="light" size="small"  className="pl1">{value}</IonButton>
                </div>

            </IonItem>
            <IonItem lines="none"  style={{paddingTop:"0em"}}>
                <IonRange className="ion-no-padding" style={{height:"24px"}} value={value} min={min} max={max} step={step} snaps={true} ticks={false}
                    onIonChange={e => setValue(e.detail.value as number)}
                    pinFormatter={customFormatter} 
                >
                </IonRange>
            </IonItem>
        </IonList>
  );
};

export default Control;
